const snack = require("../../../../../components/snack/snack");
const scrim = require("../../../../../components/scrim/scrim");
const { getReportDefinition } = require("./reportHub-report-registry");

let activeDefinition = null;
const REPORT_PDF_ENDPOINT = "server/php/report/report-pdf.php";

const AUTOCOMPLETE_IDS = [
  "reportHub_form_customer_id",
  "reportHub_form_provider_id",
  "reportHub_form_purchase_id",
  "reportHub_form_sale_id",
  "reportHub_form_transaction_id",
];

// --- Helpers de DOM ---
const getEl = (id) => document.getElementById(id);
const getElValue = (id) => getEl(id)?.value || "";

const toggleVisibility = (el, show) => el?.classList.toggle("dn", !show);

function getSelectedEntityDbid(elementId) {
  const el = getEl(elementId);
  if (!el) return "";
  try {
    const sel = JSON.parse(el.getAttribute("selected") || "[]");
    return sel.length ? String(sel[0]) : "";
  } catch (e) {
    return "";
  }
}

function clearAutocomplete(elementId) {
  const el = getEl(elementId);
  if (!el) return;

  el.setAttribute("selected", "[]");
  const chipCont = el.querySelector(".chip-cont");
  if (chipCont) chipCont.innerHTML = "";
  const input = el.querySelector(".elem");
  if (input) input.value = "";
}

function clearAllAutocompletes() {
  AUTOCOMPLETE_IDS.forEach(clearAutocomplete);
}

const getSelectedCustomerDbid = () =>
  getSelectedEntityDbid("reportHub_form_customer_id");
const getSelectedProviderDbid = () =>
  getSelectedEntityDbid("reportHub_form_provider_id");

function getAutocompleteEntityId(def) {
  const map = {
    customer: () => getSelectedCustomerDbid(),
    provider: () => getSelectedProviderDbid(),
    purchase: () => getSelectedEntityDbid("reportHub_form_purchase_id"),
    sale: () => getSelectedEntityDbid("reportHub_form_sale_id"),
    transaction: () =>
      getSelectedEntityDbid("reportHub_form_transaction_id"),
  };
  const fn = map[def.autocompleteEntity];
  return fn ? fn() : "";
}

function applyAutocompleteVisibility(def) {
  const wraps = {
    customer: getEl("reportHub-filter-customer-wrap"),
    provider: getEl("reportHub-filter-provider-wrap"),
    purchase: getEl("reportHub-filter-purchase-wrap"),
    sale: getEl("reportHub-filter-sale-wrap"),
    transaction: getEl("reportHub-filter-transaction-wrap"),
  };

  Object.keys(wraps).forEach((k) => {
    toggleVisibility(wraps[k], false);
  });

  const entityWrap = getEl("reportHub-filter-entity-wrap");
  toggleVisibility(entityWrap, def.needsAutocomplete);

  if (def.needsAutocomplete && def.autocompleteEntity) {
    toggleVisibility(wraps[def.autocompleteEntity], true);
  }
}

function applyFilterVisibility(def) {
  toggleVisibility(getEl("reportHub-filter-dates"), def.filterDateRange);
  toggleVisibility(getEl("reportHub-filter-year-wrap"), def.filterYear);

  applyAutocompleteVisibility(def);
}

export function initFilters() {
  populateYearSelect();
}

function populateYearSelect() {
  const sel = getEl("reportHub_filter_year_select");
  if (!sel || sel.getAttribute("data-hub-years") === "1") return;
  sel.setAttribute("data-hub-years", "1");
  const y = new Date().getFullYear();
  sel.innerHTML =
    `<option value="" disabled selected>Select year</option>` +
    Array.from({ length: 12 }, (_, i) => {
      const yr = y - i;
      return `<option value="${yr}">${yr}</option>`;
    }).join("");
}

function clearFilterInputs() {
  const from = getEl("reportHub_filter_date_from");
  const to = getEl("reportHub_filter_date_to");
  const yearSel = getEl("reportHub_filter_year_select");

  if (from) from.value = "";
  if (to) to.value = "";
  if (yearSel) {
    yearSel.selectedIndex = 0;
  }

  clearAllAutocompletes();
}

function updateGeneratingTitle(def) {
  const title = getEl("reportHub-generating-title");
  if (title && def && def.label) {
    title.textContent = "Generating — " + def.label;
  }
}

export function onCleanAll() {
  clearFilterInputs();
}

function executeReport(def, filters) {
  if (def.needsAutocomplete && !filters.entityId) {
    snack.start({ act: "show", id: getMissingEntitySnack(def) });
    return;
  }

  requestPdfReport(def, filters);
}

export function onSelectReport(detail) {
  const def = getReportDefinition(detail.reportId);
  if (!def) return;

  activeDefinition = def;
  clearFilterInputs();
  applyFilterVisibility(def);
  updateGeneratingTitle(def);

  const filterCard = getEl("reportHub-filter-card");

  if (def.autoPrintWithoutUI && !def.needsAutocomplete) {
    toggleVisibility(filterCard, false);
    executeReport(def, buildFiltersFromForm());
    return;
  }

  toggleVisibility(filterCard, true);
}

function buildFiltersFromForm() {
  let startDate = getElValue("reportHub_filter_date_from");
  let endDate = getElValue("reportHub_filter_date_to");
  const yearSel = getEl("reportHub_filter_year_select");
  const reportYear =
    yearSel && yearSel.value && !Number.isNaN(Number(yearSel.value))
      ? yearSel.value
      : "";

  if (
    activeDefinition &&
    activeDefinition.filterYear &&
    reportYear &&
    !startDate &&
    !endDate
  ) {
    startDate = `${reportYear}-01-01`;
    endDate = `${reportYear}-12-31`;
  }

  const filters = {
    startDate,
    endDate,
    useYear: !!reportYear,
    reportYear,
    entityId:
      activeDefinition && activeDefinition.needsAutocomplete
        ? getAutocompleteEntityId(activeDefinition)
        : "",
  };

  return filters;
}

export function onRunFilteredReport() {
  if (!activeDefinition) return;

  const filters = buildFiltersFromForm();
  if (!filters) return;

  executeReport(activeDefinition, filters);
}

function getMissingEntitySnack(def) {
  const map = {
    customer: "receivePaymentNoCustomer",
    provider: "reportHubNoProvider",
  };
  return map[def.autocompleteEntity] || "downloadError";
}

function appendFilter(formData, key, value) {
  if (value === undefined || value === null || value === "") return;

  if (typeof value === "boolean") {
    formData.append(`filters[${key}]`, value ? "1" : "0");
    return;
  }

  formData.append(`filters[${key}]`, value);
}

function buildReportPdfFormData(def, filters) {
  const formData = new FormData();

  formData.append("reportName", def.id);
  formData.append("entity", def.entity);

  Object.keys(filters || {}).forEach((key) => {
    appendFilter(formData, key, filters[key]);
  });

  return formData;
}

function requestPdfReport(def, filters) {
  scrim.showLoading();

  fetch(`./${REPORT_PDF_ENDPOINT}`, {
    method: "POST",
    body: buildReportPdfFormData(def, filters),
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente
      return response.blob();
    })
    .then((blob) => {
      // 2. Creamos un objeto URL seguro apuntando al binario en memoria
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // 3. Abrimos el visor nativo en una nueva pestaña
      const newTab = window.open(pdfUrl, "_blank");

      // Opcional: Liberar memoria cuando la pestaña se haya cerrado/cargado
      if (newTab) {
        newTab.addEventListener('load', () => {
          URL.revokeObjectURL(pdfUrl);
        }, { once: true });
      }
    })
    .catch(() => {
      snack.start({ act: "show", id: "downloadError" });
    })
    .finally(() => {
      scrim.hideLoading();
    });
}

function normalizePdfPath(filePath) {
  return String(filePath || "").trim().replace(/^["']|["']$/g, "");
}
